import WithdrawIcon from '@assets/icons/arrow-up.svg?react'
import BatchPaymentIcon from '@assets/icons/batch-payment.svg?react'
import DepositIcon from '@assets/icons/cross.svg?react'
import ExchangeIcon from '@assets/icons/exchange.svg?react'
import WalletIcon from '@assets/icons/wallet.svg?react'
import AddAccountModal from '@views/accounts/AddAccountModal/AddAccountModal'
import { paths, useMyAccountAccessQry } from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'
import { type ReactElement, useMemo } from 'react'

type PaymentButton = {
  path?: string
  func?: (modalShow: (params: any) => void) => void
  label: string
  icon: ReactElement
}

export const usePaymentButtons = (isOwnerOrAdministrator: boolean, showBatchPayment: boolean) => {
  const { accountAccess, hasAnyWritePermission } = useMyAccountAccessQry()

  const hasWriterAccountsInMultipleCurrencies = useMemo(() => {
    const writerCurrencies = new Set(accountAccess?.filter(a => a.accessLevel === 'WRITER').map(a => a.currency))
    return writerCurrencies.size >= 2
  }, [accountAccess])

  if (isOwnerOrAdministrator) {
    return [
      {
        path: paths.banking.deposit(),
        label: tr('FRONTEND.DASHBOARD.BUTTONS.DEPOSIT', 'Deposit'),
        icon: <DepositIcon />
      },
      {
        path: paths.banking.send(),
        label: tr('FRONTEND.DASHBOARD.BUTTON_SEND', 'Send'),
        icon: <WithdrawIcon />
      },
      {
        path: paths.banking.exchange(),
        label: tr('FRONTEND.DASHBOARD.BUTTONS.EXCHANGE', 'Exchange'),
        icon: <ExchangeIcon />
      },
      ...(showBatchPayment
        ? [
            {
              path: paths.banking.sendBatchPayment(),
              label: tr('FRONTEND.DASHBOARD.BUTTONS.BATCH_PAYMENT', 'Batch payment'),
              icon: <BatchPaymentIcon />
            }
          ]
        : []),
      {
        func: (modalShow: (params: any) => void) => {
          modalShow({
            content: <AddAccountModal />,
            header: tr('FRONTEND.ACCOUNTS.CREATE.TITLE', 'Add new account'),
            options: { closeOnClickOutside: true }
          })
        },
        label: tr('FRONTEND.DASHBOARD.BUTTONS.NEW_ACCOUNT', 'New account'),
        icon: <WalletIcon />
      }
    ]
  }

  const staffButtons: PaymentButton[] = [
    {
      path: paths.banking.deposit(),
      label: tr('FRONTEND.DASHBOARD.BUTTONS.DEPOSIT', 'Deposit'),
      icon: <DepositIcon />
    },
    {
      path: paths.banking.send(),
      label: tr('FRONTEND.DASHBOARD.BUTTON_SEND', 'Send'),
      icon: <WithdrawIcon />
    }
  ]

  if (hasAnyWritePermission) {
    if (hasWriterAccountsInMultipleCurrencies) {
      staffButtons.push({
        path: paths.banking.exchange(),
        label: tr('FRONTEND.DASHBOARD.BUTTONS.EXCHANGE', 'Exchange'),
        icon: <ExchangeIcon />
      })
    }
  }

  return staffButtons
}
